import { createTranslations, type Language } from '../../../i18n/types';

export default createTranslations({
  en: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Ticket',
    format: 'Format',
    side: 'Side',
    sideCt: 'Counter-Terrorists',
    sideT: 'Terrorists',
    sideAny: 'Any',
    skinLabel: 'Skin',
    practiceBots: 'Vs bots',
    playWithBots: 'Play with bots · free',
    winRangeTitle: 'Skin for a win',
    skip: 'Skip',
    // How to play (rules sheet + first-run slides)
    howtoTitle: 'How to play',
    howtoNext: 'Next',
    howtoStart: 'Got it, let’s play',
    howtoSkip: 'Skip',
    howtoSlide1Title: 'Turn-based PvP',
    howtoSlide1Text:
      'The ticket is your entry. Opponents are real players with the same ticket. The winning team splits the bank.',
    howtoSlide2Title: 'The buy doesn’t decide',
    howtoSlide2Text:
      'Everyone gets the same budget. Weapons set the style: the AWP is a rare heavy shot, the machine gun fires often and steady.',
    howtoSlide3Title: 'Read your opponent',
    howtoSlide3Text:
      'Each round you pick a stance. Watch what your opponent did last round — and counter it.',
    howtoSlide4Title: 'A skin split by contribution',
    howtoSlide4Text:
      'The bank is split by damage and utility, then paid out as a skin worth your share. Even if you die, your contribution counts. The bank fills from every ticket’s spin — a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoTryBots: 'Try it free first — vs bots',
    howtoLoopTitle: 'How a match goes',
    howtoLoopStep1: 'Pick a ticket, a side and a format — that’s your entry.',
    howtoLoopStep2: 'Buy phase: weapon, armor and utility on an equal budget.',
    howtoLoopStep3: 'Turn-based fight: every round — a stance or an action. Pick your target with a tap.',
    howtoLoopStep4: 'The match bank is split among the winners by contribution and paid out as a skin.',
    howtoStancesTitle: 'Stances',
    howtoRpsCaption: 'The arrow shows who beats whom',
    howtoStancesText:
      '[[defense|Defense]] reflects part of the damage, [[maneuver|Dodge]] lowers the enemy’s accuracy, [[attack|Attack]] boosts your fire.',
    howtoWeaponsTitle: 'Weapons',
    howtoWeaponAwp: 'AWP — all or nothing: rare shot, huge crit.',
    howtoWeaponRifle: 'Rifle — the balanced classic.',
    howtoWeaponLmg: 'Machine gun — often and steady, no crit swings.',
    howtoUtilityTitle: 'Utility',
    howtoSmokeTargetNote: 'Smoke covers an ally — tap a teammate to pick who it shields.',
    howtoUtilTeamNote: 'Smoke and flash exist only in team modes.',
    howtoMoneyTitle: 'Money',
    howtoMoney1: 'The buy budget is equal for everyone — it sets the style, not the power.',
    howtoMoney2: 'The prize is a skin split by contribution: damage + utility. Dying doesn’t erase it.',
    howtoMoney3: 'The bank fills from every ticket’s spin: a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoMoney4: 'Every ticket is one bank spin — from half up to 2.5× the ticket per spin. Pricier ticket — bigger bank.',
    history: 'History',
    partyJoin: 'Join by code',
    partyJoinPlaceholder: 'Party code',
    partyJoinAction: 'Join',
    partyShare: 'Invite friends',
    partyKick: 'Remove from party',
    partyShareText: 'Join my SHOT party — code {{code}}',
    partyErrNotFound: 'Party not found — check the code.',
    partyErrInGame: 'That party is already in a game — finish it first.',
    partyErrFull: 'That party is full.',
    partyErrInMatch: 'Finish your active match first.',
    multiaccErr: 'You cannot join here.',
    maintenanceErr: 'The game is updating — check back in a couple of minutes.',
    balanceErr: 'Not enough coins for the entry — top up your balance and come back.',
    topUpBalance: 'Top up balance',
    maintenanceBanner: 'The game is updating — matches reopen in a couple of minutes.',
    updateBanner: 'A new version is out — update to keep playing.',
    updateNow: 'Update',
    comingSoonBadge: 'Coming soon',
    comingSoonHint: 'The mode hasn’t opened yet — stay tuned.',
    partyLeaderTag: 'leader',
    partyLeave: 'Leave party',
    partyCodeLabel: 'Party code',
    partyCopy: 'Copy',
    partyCopied: 'Copied',
    partyCreatedBy: 'Created by {{name}}',
    partyLeaderBadge: 'Leader',
    partyReadyYes: 'Ready',
    partyReadyNo: 'Not ready',
    partyWaitingOthers: 'Waiting for the other players',
    partyConfirmReady: 'Confirm you are ready to start.',
    partyImReady: 'I am ready',
    partyYou: 'You',
    partyShareBtn: 'Share',
    partyReadyCount: 'Ready: {{n}} of {{m}}',
    // Modes
    mode1: '1 v 1',
    mode2: '2 v 2',
    mode5: '5 v 5',
    modeN: '{{size}} v {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'Games',
    introCard: 'Rush Mid is a Counter-Strike-style take on case battles: players enter a match with a fixed ticket, fight each other, and a win pays out a skin worth a share tied to the entry price.',
    openGamesTitle: 'Open games',
    howToPlayLink: 'how to play',
    winUpToPrefix: 'for a win up to',
    winUpToSuffix: '',
    waitingForPlayer: 'waiting for a player…',
    winRangeChip: 'a win pays',
    notEnoughShort: 'missing',
    homeAllGames: 'all games',
    createGame: 'Create game · ',
    createGameShort: 'Create game',
    gamesEmptyTitle: 'Nothing here yet',
    gamesEmpty: 'No open games yet — create the first one',
    gamesBack: 'Back to games',
    openGameTitle: 'Game',
    joinSide: 'Sit',
    confirmSitTitle: 'Join the game',
    confirmSitMessage: 'Sit in for {{amount}}?',
    confirmSitYes: 'Sit',
    gameFull: 'All seats are taken',
    partyBadge: 'party ×{{k}}',
    tabFighter: 'Fighter',
    squadTitle: 'Party',
    inviteFriends: 'Invite friends',
    leaderPicking: 'The leader is picking a game…',
    partyWontFit: 'party ×{{k}} won’t fit',
    graceLockedBadge: 'newcomer game · {{s}}s',
    graceLockedHint: 'A newcomer is warming up here. The lobby opens to everyone in {{s}}s.',
    partyFits: 'party ×{{k}} fits',
    wontFit: 'won’t fit',
    memberBadge: 'In a party ×{{k}}',
    createSheetTitle: 'Create game',
    createSheetSubtitle: 'Pick a ticket, format and side',
    botFillIn: 'Bots fill in {{s}}s',
    leaveGame: 'Leave',
    youLabel: 'you',
    gameInvite: 'Invite',
    gameShareText: 'Come join my Rush Mid game',
    gameShareButton: 'Play',
    replayTitle: 'Match replay',
    shareReplay: 'Share replay',
    replayShareText: 'Check out this Rush Mid match',
    replayShareButton: 'Watch replay',
    gameGone: 'This game has already started or closed',
    tipLabel: 'Tip',
    preparing: 'Preparing the battle…',
    loadingGame: 'Loading battle…',
    loading: 'Loading…',
    errorTitle: 'RushMid error',
    backToLobby: 'Back to games',
    reloadScreen: 'Reload screen',
    // Buy
    buyTitle: 'Buy',
    remaining: 'Remaining',
    yourFighter: 'Your fighter',
    hp: 'HP',
    armorShort: 'armor',
    weapon: 'Weapon',
    armor: 'Armor',
    grenade: 'Grenade',
    grenadeTaken: 'Taken',
    medkit: 'Medkit',
    accuracy: 'Accuracy',
    stance: 'Stance',
    stanceCenter: 'Centre',
    stanceAttack: 'Attack',
    stanceDefense: 'Defense',
    stanceManeuver: 'Dodge',
    knife: 'Knife',
    smoke: 'Smoke',
    flash: 'Flash',
    nadeSmoke: 'Smoke',
    nadeFrag: 'Frag',
    logSmoke: 'smoke',
    logAdrenaline: 'adrenaline',
    adrenaline: 'adrenaline',
    // AFK guard — a clamped player's canvas/scoreboard mark + the missed-round heads-up
    afkBadge: 'AFK',
    afkWarn: 'Miss one more round and you forfeit your winnings',
    fire: 'Fire',
    pickAlly: 'Select a teammate',
    pickEnemy: 'Select an enemy',
    confirmAction: 'Confirm',
    waiting: 'Waiting…',
    choosing: 'Choosing…',
    watchingReplay: 'Watching…',
    youWin: 'Victory',
    youLose: 'Defeat',
    sideWins: 'WIN',
    matchDraw: 'Draw',
    drawRefund: 'Coins refunded',
    botShort: 'Bot',
    copyMatchId: 'Copy match ID',
    matchIdCopied: 'Copied',
    roundN: 'Round {{round}}',
    autoStart: 'Auto-start in',
    grenadeNone: 'No',
    allies: 'Allies',
    enemies: 'Enemies',
    loadout: 'Loadout',
    toBattle: 'To battle',
    toBattleIn: 'To battle in {{sec}}s',
    statDamage: 'Damage',
    statRate: 'Rate',
    statCrit: 'Crit',
    statAccuracy: 'Accuracy',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Rifle',
    weaponLmg: 'Machine gun',
    weaponAwpBlurb: 'Hits hard but rarely. High crit — either kills or misses.',
    weaponRifleBlurb: 'Balanced damage and rate of fire.',
    weaponLmgBlurb: 'Often but weak. Steadily racks up damage.',
    // Armor labels & blurbs
    armorNone: 'No armor',
    armorLight: 'Light vest',
    armorHeavy: 'Heavy vest',
    armorNoneBlurb: 'Maximum firepower, but fragile.',
    armorLightBlurb: 'Slightly cuts damage and crit.',
    armorHeavyBlurb: 'Heavily cuts peak damage and crit — counters AWP.',
    armorNumbers: '{{points}} armor points · bullet −30% dmg, crits pierce',
    // Gear in numbers (how-it-works info sheet)
    gearInfoOpen: 'How it works',
    gearInfoTitle: 'Gear in numbers',
    gearFragInfo: 'Up to {{max}} dmg to the target — armor won’t save; shrapnel clips one more enemy. [[defense|Defense]] takes ×1.35, [[maneuver|Maneuver]] ×0.8.',
    gearSmokeInfo: 'Smoke an ally: for {{rounds}} rounds he takes −{{mit}}% bullet damage. Knife and grenade ignore smoke.',
    gearFlashInfo: 'Blinds up to 3 enemies for {{rounds}} rounds: half accuracy, no crits.',
    gearMedkitInfo: 'Heals {{frac}}% of missing HP (at least {{floor}}). You don’t shoot this round and are open to the knife.',
    gearKnifeInfo: 'Free, every round. Target not shooting or braced in [[defense|Defense]] — {{dmg}} through armor, execute at ≤30% HP. Target in [[attack|Attack]] or [[maneuver|Maneuver]] — only {{weak}}, and you eat its point-blank fire.',
    // Result
    resultWin: 'Victory',
    resultTeamWin: 'Team won',
    resultDefeat: 'Defeat',
    resultWinSub: 'Your team won — you get a skin worth your share of the bank, split by contribution (MVP).',
    resultTeamWinSub: 'Your team won. Your fighter fell, but you still earned a skin worth your share by contribution (MVP).',
    resultDefeatSub: 'The team lost — better luck next round.',
    scoreboardTitle: 'Scoreboard',
    payout: 'Win',
    total: 'Total',
    again: 'Again',
    wonShort: 'Victory',
    viewLog: 'View log',
    roundLog: 'Log',
    roundLogTitle: 'Battle log',
    roundLogEmpty: 'First round is still playing',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} raffle tickets',
    raffleChipWin: 'Win +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Win at 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    // Winner drop reveal
    dropRevealTapHint: 'Tap to continue',
    dropYouTitle: 'Your drop',
    dropLabel: 'Drop',
    watch: 'Watch',
    // Live now (spectate)
    liveNowTitle: 'Live now',
    liveEmpty: 'No matches running right now',
    liveRoundBadge: 'Live · round {{n}}',
    spectate: 'Watch',
    matchOver: 'Match over',
    logMiss: 'miss',
    logMissEvade: 'miss — dodged',
    logMissBlind: 'miss — blinded',
    logReflect: 'reflected',
    logPunish: 'return fire',
    logLegend: '✦ crit pierces armor · ⚡ adrenaline',
    logKilledBy: 'killed by',
    colKills: 'K',
    canvasMiss: 'MISS',
    canvasMissEvade: 'DODGE',
    canvasMissBlind: 'BLIND',
    // History
    historyTitle: 'History',
    back: 'Back',
    matchDetailError: 'Couldn’t load this match. It may not exist — bot practice keeps no record.',
    historySubtitle: 'Your latest Rush Mid battles.',
    historyEmptyTitle: 'You have not played yet',
    historyEmptyDescription: 'Play your first Rush Mid battle — it will show up here.',
    win: 'Victory',
    defeat: 'Defeat',
    timeJustNow: 'just now',
    timeMinAgo: '{{min}} min ago',
    timeHoursAgo: '{{hours}} h ago',
    timeDaysAgo: '{{days}} d ago',
    // Rating
    ratingTab: 'Rating',
    yourRating: 'Your rating',
    earned: 'Earned',
    rating: 'Rating',
    played: 'Played',
    wins: 'Wins',
    winsCol: 'Wins',
    losses: 'Losses',
    lossesCol: 'Losses',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Win rate',
    player: 'Player',
    topPlayers: 'Top players',
    ratingUnratedTitle: 'No rating yet',
    ratingUnratedDescription: 'Play a match in this format to get a rating.',
    ratingEmptyTitle: 'No one here yet',
    ratingEmptyDescription: 'Be the first to play in this format.',
    // Raffle
    raffleTab: 'Raffle',
  },
  ru: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Билет',
    format: 'Формат',
    side: 'Сторона',
    sideCt: 'Контр-террористы',
    sideT: 'Террористы',
    sideAny: 'Любая',
    skinLabel: 'Скин',
    practiceBots: 'С ботами',
    playWithBots: 'Играть с ботами · бесплатно',
    winRangeTitle: 'Скин за победу',
    skip: 'Пропустить',
    // Как играть (шторка правил + слайды первого входа)
    howtoTitle: 'Как играть',
    howtoNext: 'Дальше',
    howtoStart: 'Понятно, играем',
    howtoSkip: 'Пропустить',
    howtoSlide1Title: 'Пошаговый PvP',
    howtoSlide1Text:
      'Билет — твой вход в матч. Соперники — реальные игроки с таким же билетом. Победившая команда делит банк.',
    howtoSlide2Title: 'Закуп не решает',
    howtoSlide2Text:
      'Бюджет у всех одинаковый. Оружие задаёт стиль: AWP — редкий тяжёлый выстрел, пулемёт бьёт часто и ровно.',
    howtoSlide3Title: 'Читай соперника',
    howtoSlide3Text:
      'Каждый раунд выбираешь стойку. Смотри, что соперник делал в прошлом раунде — и контри его.',
    howtoSlide4Title: 'Скин — по вкладу',
    howtoSlide4Text:
      'Банк делится по урону и утилите, а выплачивается скином нужной стоимости. Даже если погиб — вклад засчитан. Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    howtoTryBots: 'Сначала попробуй бесплатно — с ботами',
    howtoLoopTitle: 'Как проходит матч',
    howtoLoopStep1: 'Выбираешь билет, сторону и формат — это твой вход в матч.',
    howtoLoopStep2: 'Закуп: оружие, броня и утилита на равный бюджет.',
    howtoLoopStep3: 'Пошаговый бой: каждый раунд — стойка или действие. Цель выбираешь тапом.',
    howtoLoopStep4: 'Банк матча делится между победителями по вкладу и выплачивается скином.',
    howtoStancesTitle: 'Стойки',
    howtoRpsCaption: 'Стрелка показывает, кто кого бьёт',
    howtoStancesText:
      '[[defense|Защита]] отражает часть урона, [[maneuver|Манёвр]] сбивает точность врага, [[attack|Атака]] усиливает твой огонь.',
    howtoWeaponsTitle: 'Оружие',
    howtoWeaponAwp: 'AWP — всё или ничего: редкий выстрел, огромный крит.',
    howtoWeaponRifle: 'Винтовка — сбалансированная классика.',
    howtoWeaponLmg: 'Пулемёт — часто и ровно, без качелей крита.',
    howtoUtilityTitle: 'Утилита',
    howtoSmokeTargetNote: 'Дым прикрывает союзника — тапни своего, чтобы выбрать, кого закрыть.',
    howtoUtilTeamNote: 'Дым и флешка — только в командных режимах.',
    howtoMoneyTitle: 'Деньги',
    howtoMoney1: 'Бюджет закупа у всех равный — он решает стиль, а не силу.',
    howtoMoney2: 'Приз — скин, он делится по вкладу: урон + утилита. Смерть вклад не стирает.',
    howtoMoney3: 'Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    howtoMoney4: 'Каждый билет — один прокрут банка: от половины до 2.5 билета за прокрут. Дороже билет — больше банк.',
    history: 'История',
    partyJoin: 'Войти по коду',
    partyJoinPlaceholder: 'Код пати',
    partyJoinAction: 'Войти',
    partyShare: 'Позвать друзей',
    partyKick: 'Убрать из пати',
    partyShareText: 'Залетай ко мне в пати SHOT — код {{code}}',
    partyErrNotFound: 'Пати не найдена — проверь код.',
    partyErrInGame: 'Пати уже в игре — сначала закончи её.',
    partyErrFull: 'Пати заполнена.',
    partyErrInMatch: 'Сначала закончи активный матч.',
    multiaccErr: 'Ты не можешь присоединиться сюда.',
    maintenanceErr: 'Идёт обновление игры — загляни через пару минут.',
    balanceErr: 'Не хватает монет на вход — пополни баланс и возвращайся.',
    topUpBalance: 'Пополнить баланс',
    maintenanceBanner: 'Идёт обновление игры — матчи откроются через пару минут.',
    updateBanner: 'Вышло обновление — обнови, чтобы играть.',
    updateNow: 'Обновить',
    comingSoonBadge: 'Скоро',
    comingSoonHint: 'Режим ещё не открыт — следи за новостями.',
    partyLeaderTag: 'лидер',
    partyLeave: 'Выйти из пати',
    partyCodeLabel: 'Код пати',
    partyCopy: 'Копировать',
    partyCopied: 'Скопировано',
    partyCreatedBy: 'Создано {{name}}',
    partyLeaderBadge: 'Лидер',
    partyReadyYes: 'Готов',
    partyReadyNo: 'Не готов',
    partyWaitingOthers: 'Ожидает остальных игроков',
    partyConfirmReady: 'Подтверди готовность, чтобы начать игру.',
    partyImReady: 'Я готов',
    partyYou: 'Ты',
    partyShareBtn: 'Поделиться',
    partyReadyCount: 'Готово: {{n}} из {{m}}',
    // Modes
    mode1: '1 на 1',
    mode2: '2 на 2',
    mode5: '5 на 5',
    modeN: '{{size}} на {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'Игры',
    introCard: 'Rush Mid — это игровой аналог кейс-баттлов в стиле Counter-Strike: игроки заходят в матч с фиксированным билетом, сражаются между собой, и победители делят банк по вкладу — каждый получает скин на стоимость своей доли.',
    openGamesTitle: 'Открытые игры',
    howToPlayLink: 'как играть',
    winUpToPrefix: 'за победу до',
    winUpToSuffix: '',
    waitingForPlayer: 'ждём игрока…',
    winRangeChip: 'за победу',
    notEnoughShort: 'не хватает',
    homeAllGames: 'все игры',
    createGame: 'Создать игру · ',
    createGameShort: 'Создать игру',
    gamesEmptyTitle: 'Здесь пока пусто',
    gamesEmpty: 'Открытых игр пока нет — создай первую',
    gamesBack: 'К списку игр',
    openGameTitle: 'Игра',
    joinSide: 'Сесть',
    confirmSitTitle: 'Сесть в игру',
    confirmSitMessage: 'Сесть в игру за {{amount}}?',
    confirmSitYes: 'Сесть',
    gameFull: 'Все места заняты',
    partyBadge: 'пати ×{{k}}',
    tabFighter: 'Боец',
    squadTitle: 'Пати',
    inviteFriends: 'Позвать друзей',
    leaderPicking: 'Лидер выбирает игру…',
    partyWontFit: 'пати ×{{k}} не влезет',
    graceLockedBadge: 'игра новичка · {{s}} с',
    graceLockedHint: 'Тут разминается новичок. Для всех откроется через {{s}} с.',
    partyFits: 'пати ×{{k}} влезет',
    wontFit: 'не влезет',
    memberBadge: 'В пати ×{{k}}',
    createSheetTitle: 'Создать игру',
    createSheetSubtitle: 'Выбери билет, формат и сторону',
    botFillIn: 'Боты добьют через {{s}} с',
    leaveGame: 'Выйти',
    youLabel: 'ты',
    gameInvite: 'Пригласить',
    gameShareText: 'Залетай ко мне в игру Rush Mid',
    gameShareButton: 'Играть',
    replayTitle: 'Реплей матча',
    shareReplay: 'Поделиться реплеем',
    replayShareText: 'Зацени этот матч в Rush Mid',
    replayShareButton: 'Смотреть реплей',
    gameGone: 'Эта игра уже началась или закрылась',
    tipLabel: 'Совет',
    preparing: 'Готовим бой…',
    loadingGame: 'Загружаем бой…',
    loading: 'Загрузка…',
    errorTitle: 'Ошибка RushMid',
    backToLobby: 'К играм',
    reloadScreen: 'Обновить экран',
    // Buy
    buyTitle: 'Закуп',
    remaining: 'Осталось',
    yourFighter: 'Твой боец',
    hp: 'HP',
    armorShort: 'бр.',
    weapon: 'Оружие',
    armor: 'Броня',
    grenade: 'Граната',
    grenadeTaken: 'Взята',
    medkit: 'Аптечка',
    accuracy: 'Точность',
    stance: 'Стойка',
    stanceCenter: 'Центр',
    stanceAttack: 'Атака',
    stanceDefense: 'Защита',
    stanceManeuver: 'Манёвр',
    knife: 'Нож',
    smoke: 'Дым',
    flash: 'Флешка',
    nadeSmoke: 'Дымовая',
    nadeFrag: 'Осколочная',
    logSmoke: 'дым',
    logAdrenaline: 'адреналин',
    adrenaline: 'адреналин',
    // Защита от AFK — метка на канвасе/скорборде у клеймённого игрока + плашка о пропуске
    afkBadge: 'AFK',
    afkWarn: 'Ещё один пропуск — останешься без выигрыша',
    fire: 'Огонь',
    pickAlly: 'Выбери своего',
    pickEnemy: 'Выбери врага',
    confirmAction: 'В бой',
    waiting: 'Ждём…',
    choosing: 'Выбирает…',
    watchingReplay: 'Смотрим…',
    youWin: 'Победа',
    youLose: 'Поражение',
    sideWins: 'ПОБЕДА',
    matchDraw: 'Ничья',
    drawRefund: 'Монеты возвращены',
    botShort: 'Бот',
    copyMatchId: 'Копировать ID матча',
    matchIdCopied: 'Скопировано',
    roundN: 'Раунд {{round}}',
    autoStart: 'Старт через',
    grenadeNone: 'Нет',
    allies: 'Союзники',
    enemies: 'Враги',
    loadout: 'Закуп',
    toBattle: 'В бой',
    toBattleIn: 'В бой через {{sec}} сек',
    statDamage: 'Урон',
    statRate: 'Темп',
    statCrit: 'Крит',
    statAccuracy: 'Точность',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Автомат',
    weaponLmg: 'Пулемёт',
    weaponAwpBlurb: 'Бьёт сильно, но редко. Высокий крит — либо выносит, либо мажет.',
    weaponRifleBlurb: 'Сбалансированный урон и темп.',
    weaponLmgBlurb: 'Часто, но слабо. Ровно набивает урон.',
    // Armor labels & blurbs
    armorNone: 'Без брони',
    armorLight: 'Лёгкий жилет',
    armorHeavy: 'Тяжёлый жилет',
    armorNoneBlurb: 'Максимум огневой мощи, но хрупкий.',
    armorLightBlurb: 'Немного режет урон и крит.',
    armorHeavyBlurb: 'Сильно режет пиковый урон и крит — против AWP.',
    armorNumbers: '{{points}} очков брони · пуля −30% урона, крит пробивает',
    // Снаряжение в цифрах (шторка «как работает»)
    gearInfoOpen: 'Как работает?',
    gearInfoTitle: 'Снаряжение в цифрах',
    gearFragInfo: 'До {{max}} урона по цели — броня не спасает; осколок задевает ещё одного врага. По [[defense|Защите]] ×1.35, по [[maneuver|Манёвру]] ×0.8.',
    gearSmokeInfo: 'Дым на союзника: {{rounds}} раунда он получает −{{mit}}% урона от пуль. Нож и граната дым игнорируют.',
    gearFlashInfo: 'Слепит до 3 врагов на {{rounds}} раунда: точность вдвое ниже, крита нет.',
    gearMedkitInfo: 'Лечит {{frac}}% нехватки HP (минимум {{floor}}). В этот раунд ты не стреляешь и открыт для ножа.',
    gearKnifeInfo: 'Бесплатный, каждый раунд. Цель не стреляет или сидит в [[defense|Защите]] — {{dmg}} сквозь броню, при HP ≤ 30% — казнь. Цель в [[attack|Атаке]] или [[maneuver|Манёвре]] — всего {{weak}}, и ты ловишь её выстрел в упор.',
    // Result
    resultWin: 'Победа',
    resultTeamWin: 'Команда победила',
    resultDefeat: 'Поражение',
    resultWinSub: 'Команда победила — ты получаешь скин на стоимость своей доли банка, по вкладу (MVP).',
    resultTeamWinSub: 'Команда победила. Боец пал, но ты всё равно получил скин по своей доле — по вкладу (MVP).',
    resultDefeatSub: 'Команда проиграла — в следующий раз повезёт.',
    scoreboardTitle: 'Таблица',
    payout: 'Выигрыш',
    total: 'Итог',
    again: 'Ещё раз',
    wonShort: 'Победили',
    viewLog: 'Посмотреть лог',
    roundLog: 'Лог',
    roundLogTitle: 'Ход боя',
    roundLogEmpty: 'Первый раунд ещё идёт',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} билетов розыгрыша',
    raffleChipWin: 'Победа +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Трипл +{{n}}',
    raffleChipQuad: 'Квадра +{{n}}',
    raffleChipAce: 'Эйс +{{n}}',
    raffleChipOneHp: 'Победа с 1 HP +{{n}}',
    raffleChipClutch2: 'Клатч 1v2 +{{n}}',
    raffleChipClutch3: 'Клатч 1v3 +{{n}}',
    // Ревил дропа победителей
    dropRevealTapHint: 'Нажми, чтобы продолжить',
    dropYouTitle: 'Твой дроп',
    dropLabel: 'Дроп',
    watch: 'Посмотреть',
    // Идут сейчас (спектатор)
    liveNowTitle: 'Идут сейчас',
    liveEmpty: 'Сейчас никто не играет',
    liveRoundBadge: 'Идёт бой · раунд {{n}}',
    spectate: 'Смотреть',
    matchOver: 'Матч завершён',
    logMiss: 'мимо',
    logMissEvade: 'мимо — уворот',
    logMissBlind: 'мимо — ослеплён',
    logReflect: 'отражено',
    logPunish: 'ответный огонь',
    logLegend: '✦ крит пробивает броню · ⚡ адреналин',
    logKilledBy: 'убил',
    colKills: 'К',
    canvasMiss: 'МИМО',
    canvasMissEvade: 'УВОРОТ',
    canvasMissBlind: 'ОСЛЕП',
    // History
    historyTitle: 'История',
    back: 'Назад',
    matchDetailError: 'Не получилось загрузить матч. Возможно, записи нет — тренировка с ботами не сохраняется.',
    historySubtitle: 'Твои последние бои в Rush Mid.',
    historyEmptyTitle: 'Ты ещё не играл',
    historyEmptyDescription: 'Сыграй первый бой в Rush Mid — он появится здесь.',
    win: 'Победа',
    defeat: 'Поражение',
    timeJustNow: 'только что',
    timeMinAgo: '{{min}} мин назад',
    timeHoursAgo: '{{hours}} ч назад',
    timeDaysAgo: '{{days}} дн назад',
    // Rating
    ratingTab: 'Рейтинг',
    yourRating: 'Твой рейтинг',
    earned: 'Заработано',
    rating: 'Рейтинг',
    played: 'Сыграно',
    wins: 'Побед',
    winsCol: 'Победы',
    losses: 'Поражений',
    lossesCol: 'Поражения',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Винрейт',
    player: 'Игрок',
    topPlayers: 'Топ игроков',
    ratingUnratedTitle: 'Рейтинга пока нет',
    ratingUnratedDescription: 'Сыграй матч в этом формате, чтобы получить рейтинг.',
    ratingEmptyTitle: 'Здесь пока пусто',
    ratingEmptyDescription: 'Сыграй первым в этом формате.',
    // Raffle
    raffleTab: 'Розыгрыш',
  },
  uz: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'Bilet',
    format: 'Format',
    side: 'Tomon',
    sideCt: 'Kontr-terrorchilar',
    sideT: 'Terrorchilar',
    sideAny: 'Har qanday',
    skinLabel: 'Skin',
    practiceBots: "Botlar bilan",
    playWithBots: 'Botlar bilan oʻynash · bepul',
    winRangeTitle: 'Gʻalaba uchun skin',
    skip: 'Oʻtkazib yuborish',
    // Qanday o'ynash (qoidalar + birinchi kirish slaydlari)
    howtoTitle: 'Qanday oʻynash',
    howtoNext: 'Keyingi',
    howtoStart: 'Tushunarli, oʻynaymiz',
    howtoSkip: 'Oʻtkazib yuborish',
    howtoSlide1Title: 'Navbatma-navbat PvP',
    howtoSlide1Text:
      'Bilet — sening kirishing. Raqiblar — xuddi shu biletli haqiqiy oʻyinchilar. Gʻolib jamoa bankni boʻlishadi.',
    howtoSlide2Title: 'Xarid hal qilmaydi',
    howtoSlide2Text:
      'Hammada bir xil byudjet. Qurol uslubni belgilaydi: AWP — kam otadigan ogʻir zarba, pulemyot tez va barqaror otadi.',
    howtoSlide3Title: 'Raqibni oʻqi',
    howtoSlide3Text:
      'Har raundda turish tanlaysan. Raqib oʻtgan raundda nima qilganini koʻr — va unga qarshi oʻyna.',
    howtoSlide4Title: 'Skin — hissaga koʻra',
    howtoSlide4Text:
      'Bank zarar va utilita boʻyicha boʻlinadi, soʻng shu qiymatdagi skin sifatida beriladi. Oʻlsang ham hissang hisobda. Bank har biletning aylanishidan toʻladi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    howtoTryBots: 'Avval bepul sinab koʻr — botlar bilan',
    howtoLoopTitle: 'Match qanday oʻtadi',
    howtoLoopStep1: 'Bilet, tomon va formatni tanlaysan — bu sening kirishing.',
    howtoLoopStep2: "Xarid: teng byudjetga qurol, zirh va utilita.",
    howtoLoopStep3: "Navbatma-navbat jang: har raund — turish yoki harakat. Nishonni tap bilan tanlaysan.",
    howtoLoopStep4: 'Match banki gʻoliblar orasida hissaga koʻra boʻlinadi va skin sifatida beriladi.',
    howtoStancesTitle: 'Turishlar',
    howtoRpsCaption: 'Strelka kim kimni yengishini koʻrsatadi',
    howtoStancesText:
      "[[defense|Himoya]] zararning bir qismini qaytaradi, [[maneuver|Manyovr]] dushman aniqligini pasaytiradi, [[attack|Hujum]] otishingni kuchaytiradi.",
    howtoWeaponsTitle: 'Qurollar',
    howtoWeaponAwp: "AWP — hammasi yoki hech narsa: kam otadi, ulkan krit.",
    howtoWeaponRifle: 'Vintovka — muvozanatli klassika.',
    howtoWeaponLmg: "Pulemyot — tez va barqaror, krit tebranishlarisiz.",
    howtoUtilityTitle: 'Utilita',
    howtoSmokeTargetNote: "Tutun sherikni yopadi — kimni yopishni sherikni tap qilib tanlaysan.",
    howtoUtilTeamNote: "Tutun va flesh faqat jamoaviy rejimlarda bor.",
    howtoMoneyTitle: 'Pul',
    howtoMoney1: "Xarid byudjeti hammada teng — u uslubni belgilaydi, kuchni emas.",
    howtoMoney2: 'Mukofot — skin, u hissaga koʻra boʻlinadi: zarar + utilita. Oʻlim hissani oʻchirmaydi.',
    howtoMoney3: 'Bank har biletning aylanishidan toʻladi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    howtoMoney4: "Har bilet — bankning bitta aylanishi: har aylanishda yarmidan 2.5 biletgacha. Bilet qimmatroq — bank kattaroq.",
    history: 'Tarix',
    partyJoin: 'Kod bilan kirish',
    partyJoinPlaceholder: 'Parti kodi',
    partyJoinAction: 'Kirish',
    partyShare: 'Doʻstlarni chaqirish',
    partyKick: 'Partiyadan chiqarish',
    partyShareText: 'SHOT partimga qoʻshil — kod {{code}}',
    partyErrNotFound: 'Parti topilmadi — kodni tekshir.',
    partyErrInGame: 'Bu parti allaqachon oʻyinda — avval uni tugatinglar.',
    partyErrFull: 'Parti toʻlgan.',
    partyErrInMatch: 'Avval faol matchni tugat.',
    multiaccErr: 'Bu yerga qoʻshila olmaysan.',
    maintenanceErr: 'Oʻyin yangilanmoqda — bir-ikki daqiqadan soʻng qaytib kel.',
    balanceErr: 'Kirish uchun tanga yetmaydi — balansni toʻldirib qayt.',
    topUpBalance: 'Balansni toʻldirish',
    maintenanceBanner: 'Oʻyin yangilanmoqda — oʻyinlar bir-ikki daqiqada ochiladi.',
    updateBanner: 'Yangilanish chiqdi — oʻynash uchun yangila.',
    updateNow: 'Yangilash',
    comingSoonBadge: 'Tez orada',
    comingSoonHint: 'Rejim hali ochilmadi — kuzatib bor.',
    partyLeaderTag: 'lider',
    partyLeave: 'Partidan chiqish',
    partyCodeLabel: 'Parti kodi',
    partyCopy: 'Nusxa olish',
    partyCopied: 'Nusxa olindi',
    partyCreatedBy: '{{name}} yaratdi',
    partyLeaderBadge: 'Lider',
    partyReadyYes: 'Tayyor',
    partyReadyNo: 'Tayyor emas',
    partyWaitingOthers: 'Qolgan oʻyinchilar kutilyapti',
    partyConfirmReady: 'Boshlash uchun tayyorligingni tasdiqla.',
    partyImReady: 'Men tayyorman',
    partyYou: 'Sen',
    partyShareBtn: 'Ulashish',
    partyReadyCount: 'Tayyor: {{n}}/{{m}}',
    // Modes
    mode1: '1 ga 1',
    mode2: '2 ga 2',
    mode5: '5 ga 5',
    modeN: '{{size}} ga {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'Oʻyinlar',
    introCard: 'Rush Mid — Counter-Strike uslubidagi keys-battl oʻyini: oʻyinchilar belgilangan bilet bilan matchga kiradi, bir-biri bilan jang qiladi va gʻoliblar bankni hissaga koʻra boʻlishadi — har biri oʻz ulushi qiymatidagi skin oladi.',
    openGamesTitle: 'Ochiq oʻyinlar',
    howToPlayLink: 'qanday oʻynaladi',
    winUpToPrefix: 'gʻalaba uchun',
    winUpToSuffix: 'gacha',
    waitingForPlayer: 'oʻyinchini kutamiz…',
    winRangeChip: 'gʻalaba uchun',
    notEnoughShort: 'yetmaydi:',
    homeAllGames: 'barcha oʻyinlar',
    createGame: 'Oʻyin yaratish · ',
    createGameShort: 'Oʻyin yaratish',
    gamesEmptyTitle: 'Hozircha boʻsh',
    gamesEmpty: 'Hali ochiq oʻyinlar yoʻq — birinchisini yarat',
    gamesBack: "Oʻyinlar roʻyxatiga",
    openGameTitle: "Oʻyin",
    joinSide: 'Oʻtirish',
    confirmSitTitle: 'Oʻyinga qoʻshilish',
    confirmSitMessage: '{{amount}} evaziga oʻtirasanmi?',
    confirmSitYes: 'Oʻtirish',
    gameFull: 'Barcha joylar band',
    partyBadge: 'parti ×{{k}}',
    tabFighter: 'Jangchi',
    squadTitle: 'Parti',
    inviteFriends: 'Doʻstlarni chaqirish',
    leaderPicking: 'Lider oʻyin tanlayapti…',
    partyWontFit: 'parti ×{{k}} sigʻmaydi',
    graceLockedBadge: 'yangi oʻyinchi · {{s}} s',
    graceLockedHint: 'Bu yerda yangi oʻyinchi qizdirmoqda. Hamma uchun {{s}} s dan keyin ochiladi.',
    partyFits: 'parti ×{{k}} sigʻadi',
    wontFit: 'sigʻmaydi',
    memberBadge: 'Parti ×{{k}}',
    createSheetTitle: 'Oʻyin yaratish',
    createSheetSubtitle: 'Bilet, format va tomonni tanla',
    botFillIn: 'Botlar {{s}} s dan keyin toʻldiradi',
    leaveGame: 'Chiqish',
    youLabel: 'sen',
    gameInvite: 'Taklif qilish',
    gameShareText: "Rush Mid oʻyinimga qoʻshil",
    gameShareButton: 'Oʻynash',
    replayTitle: 'Match replayi',
    shareReplay: 'Replayni ulashish',
    replayShareText: 'Bu Rush Mid matchiga qara',
    replayShareButton: "Replayni koʻrish",
    gameGone: 'Bu oʻyin allaqachon boshlangan yoki yopilgan',
    tipLabel: 'Maslahat',
    preparing: 'Jang tayyorlanmoqda…',
    loadingGame: 'Jang yuklanmoqda…',
    loading: 'Yuklanmoqda…',
    errorTitle: 'RushMid xatosi',
    backToLobby: 'Oʻyinlarga qaytish',
    reloadScreen: 'Ekranni yangilash',
    // Buy
    buyTitle: 'Xarid',
    remaining: 'Qoldi',
    yourFighter: 'Sening jangching',
    hp: 'HP',
    armorShort: 'zirh',
    weapon: 'Qurol',
    armor: 'Zirh',
    grenade: 'Granata',
    grenadeTaken: 'Olindi',
    medkit: 'Aptechka',
    accuracy: 'Aniqlik',
    stance: 'Holat',
    stanceCenter: 'Markaz',
    stanceAttack: 'Hujum',
    stanceDefense: 'Himoya',
    stanceManeuver: 'Manyovr',
    knife: 'Pichoq',
    smoke: 'Tutun',
    flash: 'Flesh',
    nadeSmoke: 'Tutun',
    nadeFrag: 'Oskolka',
    logSmoke: 'tutun',
    logAdrenaline: 'adrenalin',
    adrenaline: 'adrenalin',
    // AFK himoyasi — chetlashtirilgan o'yinchining canvas/jadval belgisi + o'tkazib yuborish ogohlantiruvi
    afkBadge: 'AFK',
    afkWarn: 'Yana bir raundni oʻtkazib yuborsang — yutuqsiz qolasan',
    fire: 'Otish',
    pickAlly: 'Sherikni tanla',
    pickEnemy: 'Dushmanni tanla',
    confirmAction: 'Jangga',
    waiting: 'Kutilmoqda…',
    choosing: 'Tanlamoqda…',
    watchingReplay: 'Koʻrilmoqda…',
    youWin: 'Gʻalaba',
    youLose: 'Magʻlubiyat',
    sideWins: 'YUTDI',
    matchDraw: 'Durang',
    drawRefund: 'Tangalar qaytarildi',
    botShort: 'Bot',
    copyMatchId: 'Match ID nusxa',
    matchIdCopied: 'Nusxa olindi',
    roundN: 'Raund {{round}}',
    autoStart: 'Avtostart',
    grenadeNone: 'Yoʻq',
    allies: 'Ittifoqchilar',
    enemies: 'Raqiblar',
    loadout: 'Jihoz',
    toBattle: 'Jangga',
    toBattleIn: '{{sec}}s dan keyin jangga',
    statDamage: 'Zarar',
    statRate: 'Temp',
    statCrit: 'Krit',
    statAccuracy: 'Aniqlik',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'Avtomat',
    weaponLmg: 'Pulemyot',
    weaponAwpBlurb: 'Kuchli uradi, lekin kamdan-kam. Yuqori krit — yo oʻldiradi, yo tegmaydi.',
    weaponRifleBlurb: 'Muvozanatli zarar va oʻq otish tezligi.',
    weaponLmgBlurb: 'Tez-tez, lekin kuchsiz. Bir tekisda zarar toʻplaydi.',
    // Armor labels & blurbs
    armorNone: 'Zirhsiz',
    armorLight: 'Yengil jilet',
    armorHeavy: 'Ogʻir jilet',
    armorNoneBlurb: 'Maksimal oʻt kuchi, lekin moʻrt.',
    armorLightBlurb: 'Zarar va kritni biroz kamaytiradi.',
    armorHeavyBlurb: 'Choʻqqi zarar va kritni kuchli kamaytiradi — AWPga qarshi.',
    armorNumbers: '{{points}} bron ochkosi · oʻq −30% zarar, krit teshib oʻtadi',
    // Jihozlar raqamlarda (qanday ishlaydi sheet)
    gearInfoOpen: 'Qanday ishlaydi?',
    gearInfoTitle: 'Jihozlar raqamlarda',
    gearFragInfo: 'Nishonga {{max}} gacha zarar — bron qutqarmaydi; parcha yana bitta dushmanga tegadi. [[defense|Himoyaga]] ×1.35, [[maneuver|Manyovrga]] ×0.8.',
    gearSmokeInfo: 'Tutun sherikka: {{rounds}} raund davomida oʻqdan −{{mit}}% zarar oladi. Pichoq va granata tutunni pisand qilmaydi.',
    gearFlashInfo: '{{rounds}} raundga 3 tagacha dushmanni koʻr qiladi: aniqlik ikki baravar past, krit yoʻq.',
    gearMedkitInfo: 'Yetishmayotgan HP ning {{frac}}% ini davolaydi (kamida {{floor}}). Bu raundda otmaysan va pichoqqa ochiqsan.',
    gearKnifeInfo: 'Bepul, har raund. Nishon otmayotgan yoki [[defense|Himoyada]] boʻlsa — bron orqali {{dmg}}, HP ≤ 30% da qatl. [[attack|Hujum]] yoki [[maneuver|Manyovrda]] boʻlsa — bor-yoʻgʻi {{weak}}, ustiga uning oʻqini yaqindan yeysan.',
    // Result
    resultWin: 'Gʻalaba',
    resultTeamWin: 'Jamoa gʻalaba qozondi',
    resultDefeat: 'Magʻlubiyat',
    resultWinSub: 'Jamoa gʻalaba qozondi — hissangga koʻra ulushing qiymatidagi skinni olasan (MVP).',
    resultTeamWinSub: 'Jamoa gʻalaba qozondi. Jangching halok boʻldi, lekin hissangga koʻra skin ulushini olding (MVP).',
    resultDefeatSub: "Jamoa yutqazdi — keyingi safar omad kulib boqadi.",
    scoreboardTitle: 'Jadval',
    payout: 'Yutuq',
    total: 'Yakun',
    again: 'Yana bir bor',
    wonShort: 'Yutdi',
    viewLog: "Logni koʻrish",
    roundLog: 'Log',
    roundLogTitle: 'Jang jarayoni',
    roundLogEmpty: 'Birinchi raund hali davom etmoqda',
    // Raffle tickets row — earned from this ranked match
    raffleTicketsTitle: '+{{n}} yutuq bileti',
    raffleChipWin: 'Gʻalaba +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: '1 HP bilan gʻalaba +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    // Yutuvchilar droping reveal
    dropRevealTapHint: 'Davom etish uchun bos',
    dropYouTitle: 'Sening droping',
    dropLabel: 'Drop',
    watch: "Koʻrish",
    // Hozir ketmoqda (tomoshabin)
    liveNowTitle: 'Hozir ketmoqda',
    liveEmpty: 'Hozir hech kim oʻynamayapti',
    liveRoundBadge: 'Jang ketmoqda · raund {{n}}',
    spectate: "Koʻrish",
    matchOver: 'Match tugadi',
    logMiss: 'tegmadi',
    logMissEvade: 'tegmadi — chap berdi',
    logMissBlind: 'tegmadi — koʻr boʻlgan',
    logReflect: 'qaytarildi',
    logPunish: 'javob oʻqi',
    logLegend: '✦ krit bronni teshadi · ⚡ adrenalin',
    logKilledBy: "oʻldirdi",
    colKills: 'K',
    canvasMiss: 'TEGMADI',
    canvasMissEvade: 'CHAP BERDI',
    canvasMissBlind: 'KOʻR',
    // History
    historyTitle: 'Tarix',
    back: 'Orqaga',
    matchDetailError: 'Matchni yuklab boʻlmadi. Yozuv yoʻq boʻlishi mumkin — botlar bilan mashq saqlanmaydi.',
    historySubtitle: "Sening Rush Mid'dagi soʻnggi janglaring.",
    historyEmptyTitle: 'Sen hali oʻynamagansan',
    historyEmptyDescription: "Rush Mid'da birinchi jangingni oʻyna — u shu yerda paydo boʻladi.",
    win: 'Gʻalaba',
    defeat: 'Magʻlubiyat',
    timeJustNow: 'hozirgina',
    timeMinAgo: '{{min}} daq oldin',
    timeHoursAgo: '{{hours}} soat oldin',
    timeDaysAgo: '{{days}} kun oldin',
    // Rating
    ratingTab: 'Reyting',
    yourRating: 'Sening reytinging',
    earned: 'Ishlangan',
    rating: 'Reyting',
    played: 'Oʻynaldi',
    wins: 'Gʻalabalar',
    winsCol: 'Gʻalabalar',
    losses: 'Magʻlubiyatlar',
    lossesCol: 'Magʻlubiyatlar',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Gʻalaba %',
    player: 'Oʻyinchi',
    topPlayers: 'Eng yaxshi oʻyinchilar',
    ratingUnratedTitle: 'Hali reyting yoʻq',
    ratingUnratedDescription: 'Reyting olish uchun bu formatda oʻyna.',
    ratingEmptyTitle: 'Hali boʻsh',
    ratingEmptyDescription: 'Bu formatda birinchi boʻlib oʻyna.',
    // Raffle
    raffleTab: 'Yutuq',
  },
  fa: {
    // Lobby
    lobbyTitle: 'Rush Mid',
    ticket: 'بلیت',
    format: 'قالب',
    side: 'تیم',
    sideCt: 'کانتر-تروریست',
    sideT: 'تروریست',
    sideAny: 'فرقی ندارد',
    skinLabel: 'اسکین',
    practiceBots: 'مقابل بات',
    playWithBots: 'بازی با بات · رایگان',
    winRangeTitle: 'اسکین برای برد',
    skip: 'رد کن',
    // How to play (rules sheet + first-run slides)
    howtoTitle: 'چطور بازی کنیم',
    howtoNext: 'بعدی',
    howtoStart: 'فهمیدم، بریم',
    howtoSkip: 'رد کن',
    howtoSlide1Title: 'PvP نوبتی',
    howtoSlide1Text:
      'بلیت ورودی توست. حریف‌ها بازیکن‌های واقعی با همان بلیت‌اند. تیم برنده بانک را تقسیم می‌کند.',
    howtoSlide2Title: 'خرید تعیین‌کننده نیست',
    howtoSlide2Text:
      'بودجه همه یکی است. سلاح سبک بازی را می‌سازد: AWP شلیک سنگین و کم‌شمار است، مسلسل زیاد و یکنواخت می‌زند.',
    howtoSlide3Title: 'حریفت را بخوان',
    howtoSlide3Text: 'هر راند یک ژست انتخاب می‌کنی. ببین حریفت راند قبل چه کرد — و جوابش را بده.',
    howtoSlide4Title: 'اسکین به نسبت سهم',
    howtoSlide4Text:
      'بانک بر پایه دمیج و آیتم تقسیم می‌شود و به شکل اسکینی به ارزش سهم تو پرداخت می‌شود. حتی اگر بمیری، سهمت حساب است. بانک از چرخش هر بلیت پر می‌شود — برد دست‌کم اسکینی به ارزش ورودی +50% می‌دهد، سقف ×5 است.',
    howtoTryBots: 'اول رایگان امتحان کن — مقابل بات',
    howtoLoopTitle: 'یک مسابقه چطور می‌گذرد',
    howtoLoopStep1: 'بلیت، تیم و قالب را انتخاب کن — این ورودی توست.',
    howtoLoopStep2: 'مرحله خرید: سلاح، جلیقه و آیتم با بودجه برابر.',
    howtoLoopStep3: 'نبرد نوبتی: هر راند یک ژست یا یک کار. هدفت را با یک لمس انتخاب کن.',
    howtoLoopStep4: 'بانک مسابقه به نسبت سهم بین برنده‌ها تقسیم و به شکل اسکین پرداخت می‌شود.',
    howtoStancesTitle: 'ژست‌ها',
    howtoRpsCaption: 'فلش نشان می‌دهد چه چیزی چه چیزی را می‌برد',
    howtoStancesText:
      '[[defense|دفاع]] بخشی از دمیج را برمی‌گرداند، [[maneuver|جاخالی]] دقت دشمن را کم می‌کند، [[attack|حمله]] آتش تو را بیشتر می‌کند.',
    howtoWeaponsTitle: 'سلاح‌ها',
    howtoWeaponAwp: 'AWP — همه یا هیچ: شلیک کم، کریت سنگین.',
    howtoWeaponRifle: 'رایفل — کلاسیک متعادل.',
    howtoWeaponLmg: 'مسلسل — زیاد و یکنواخت، بدون نوسان کریت.',
    howtoUtilityTitle: 'آیتم‌ها',
    howtoSmokeTargetNote: 'دود روی هم‌تیمی می‌نشیند — یکی را لمس کن تا زیر پوششش بگیری.',
    howtoUtilTeamNote: 'دود و فلش فقط در حالت‌های تیمی هستند.',
    howtoMoneyTitle: 'پول',
    howtoMoney1: 'بودجه خرید برای همه برابر است — سبک را می‌سازد، نه قدرت را.',
    howtoMoney2: 'جایزه اسکینی است که به نسبت سهم تقسیم می‌شود: دمیج + آیتم. مردن پاکش نمی‌کند.',
    howtoMoney3: 'بانک از چرخش هر بلیت پر می‌شود: برد دست‌کم اسکینی به ارزش ورودی +50% می‌دهد، سقف ×5 است.',
    howtoMoney4: 'هر بلیت یک چرخش بانک است — از نصف تا 2.5 برابر بلیت در هر چرخش. بلیت گران‌تر — بانک بزرگ‌تر.',
    history: 'تاریخچه',
    partyJoin: 'ورود با کد',
    partyJoinPlaceholder: 'کد پارتی',
    partyJoinAction: 'وارد شو',
    partyShare: 'دعوت دوستان',
    partyKick: 'حذف از پارتی',
    partyShareText: 'به پارتی من در SHOT بیا — کد {{code}}',
    partyErrNotFound: 'پارتی پیدا نشد — کد را بررسی کن.',
    partyErrInGame: 'آن پارتی در بازی است — اول تمامش کن.',
    partyErrFull: 'آن پارتی پر است.',
    partyErrInMatch: 'اول مسابقه فعالت را تمام کن.',
    multiaccErr: 'نمی‌توانی اینجا وارد شوی.',
    maintenanceErr: 'بازی در حال به‌روزرسانی است — چند دقیقه دیگر سر بزن.',
    balanceErr: 'سکه برای ورودی کافی نیست — موجودیت را شارژ کن و برگرد.',
    topUpBalance: 'شارژ موجودی',
    maintenanceBanner: 'بازی در حال به‌روزرسانی است — مسابقه‌ها چند دقیقه دیگر باز می‌شوند.',
    updateBanner: 'نسخه تازه آمده — برای ادامه بازی به‌روز کن.',
    updateNow: 'به‌روزرسانی',
    comingSoonBadge: 'به‌زودی',
    comingSoonHint: 'این حالت هنوز باز نشده — منتظر بمان.',
    partyLeaderTag: 'سرگروه',
    partyLeave: 'خروج از پارتی',
    partyCodeLabel: 'کد پارتی',
    partyCopy: 'کپی',
    partyCopied: 'کپی شد',
    partyCreatedBy: 'ساخته {{name}}',
    partyLeaderBadge: 'سرگروه',
    partyReadyYes: 'آماده',
    partyReadyNo: 'آماده نیست',
    partyWaitingOthers: 'منتظر بقیه بازیکن‌ها',
    partyConfirmReady: 'تأیید کن که آماده شروعی.',
    partyImReady: 'آماده‌ام',
    partyYou: 'تو',
    partyShareBtn: 'اشتراک',
    partyReadyCount: 'آماده: {{n}} از {{m}}',
    // Modes
    mode1: '1 v 1',
    mode2: '2 v 2',
    mode5: '5 v 5',
    modeN: '{{size}} v {{size}}',
    // Open games (browse / create / slot grid)
    gamesTab: 'بازی‌ها',
    introCard:
      'Rush Mid روایت Counter-Strike از نبرد کیس است: بازیکن‌ها با بلیتی ثابت وارد مسابقه می‌شوند، با هم می‌جنگند و برد اسکینی به ارزش سهمی وابسته به قیمت ورودی می‌دهد.',
    openGamesTitle: 'بازی‌های باز',
    howToPlayLink: 'چطور بازی کنیم',
    winUpToPrefix: 'برای برد تا',
    winUpToSuffix: '',
    waitingForPlayer: 'منتظر بازیکن…',
    winRangeChip: 'برد می‌دهد',
    notEnoughShort: 'کم داری',
    homeAllGames: 'همه بازی‌ها',
    createGame: 'ساخت بازی · ',
    createGameShort: 'ساخت بازی',
    gamesEmptyTitle: 'هنوز چیزی اینجا نیست',
    gamesEmpty: 'هنوز بازی بازی نیست — اولی را بساز',
    gamesBack: 'برگشت به بازی‌ها',
    openGameTitle: 'بازی',
    joinSide: 'بنشین',
    confirmSitTitle: 'ورود به بازی',
    confirmSitMessage: 'به {{amount}} بنشینی؟',
    confirmSitYes: 'بنشین',
    gameFull: 'همه صندلی‌ها پر است',
    partyBadge: 'پارتی ×{{k}}',
    tabFighter: 'مبارز',
    squadTitle: 'پارتی',
    inviteFriends: 'دعوت دوستان',
    leaderPicking: 'سرگروه در حال انتخاب بازی است…',
    partyWontFit: 'پارتی ×{{k}} جا نمی‌شود',
    graceLockedBadge: 'بازی تازه‌کار · {{s}} ثانیه',
    graceLockedHint: 'یک تازه‌کار اینجا گرم می‌کند. لابی تا {{s}} ثانیه دیگر برای همه باز می‌شود.',
    partyFits: 'پارتی ×{{k}} جا می‌شود',
    wontFit: 'جا نمی‌شود',
    memberBadge: 'در پارتی ×{{k}}',
    createSheetTitle: 'ساخت بازی',
    createSheetSubtitle: 'بلیت، قالب و تیم را انتخاب کن',
    botFillIn: 'بات‌ها تا {{s}} ثانیه دیگر پر می‌کنند',
    leaveGame: 'خروج',
    youLabel: 'تو',
    gameInvite: 'دعوت',
    gameShareText: 'به بازی Rush Mid من بیا',
    gameShareButton: 'بازی کن',
    replayTitle: 'پخش مسابقه',
    shareReplay: 'اشتراک پخش',
    replayShareText: 'این مسابقه Rush Mid را ببین',
    replayShareButton: 'دیدن پخش',
    gameGone: 'این بازی شروع شده یا بسته شده',
    tipLabel: 'نکته',
    preparing: 'در حال آماده‌سازی نبرد…',
    loadingGame: 'در حال بارگذاری نبرد…',
    loading: 'در حال بارگذاری…',
    errorTitle: 'خطای RushMid',
    backToLobby: 'برگشت به بازی‌ها',
    reloadScreen: 'بارگذاری دوباره صفحه',
    // Buy
    buyTitle: 'خرید',
    remaining: 'باقی‌مانده',
    yourFighter: 'مبارز تو',
    hp: 'HP',
    armorShort: 'جلیقه',
    weapon: 'سلاح',
    armor: 'جلیقه',
    grenade: 'نارنجک',
    grenadeTaken: 'برداشته شد',
    medkit: 'کیت درمان',
    accuracy: 'دقت',
    stance: 'ژست',
    stanceCenter: 'وسط',
    stanceAttack: 'حمله',
    stanceDefense: 'دفاع',
    stanceManeuver: 'جاخالی',
    knife: 'چاقو',
    smoke: 'دود',
    flash: 'فلش',
    nadeSmoke: 'دود',
    nadeFrag: 'ترکشی',
    logSmoke: 'دود',
    logAdrenaline: 'آدرنالین',
    adrenaline: 'آدرنالین',
    // AFK guard
    afkBadge: 'AFK',
    afkWarn: 'یک راند دیگر را از دست بدهی، بردت را می‌بازی',
    fire: 'شلیک',
    pickAlly: 'یک هم‌تیمی انتخاب کن',
    pickEnemy: 'یک دشمن انتخاب کن',
    confirmAction: 'تأیید',
    waiting: 'در انتظار…',
    choosing: 'در حال انتخاب…',
    watchingReplay: 'در حال تماشا…',
    youWin: 'برد',
    youLose: 'باخت',
    sideWins: 'برد',
    matchDraw: 'مساوی',
    drawRefund: 'سکه‌ها برگشت',
    botShort: 'بات',
    copyMatchId: 'کپی شناسه مسابقه',
    matchIdCopied: 'کپی شد',
    roundN: 'راند {{round}}',
    autoStart: 'شروع خودکار تا',
    grenadeNone: 'ندارد',
    allies: 'هم‌تیمی‌ها',
    enemies: 'دشمن‌ها',
    loadout: 'تجهیزات',
    toBattle: 'به نبرد',
    toBattleIn: 'به نبرد تا {{sec}} ثانیه',
    statDamage: 'دمیج',
    statRate: 'سرعت شلیک',
    statCrit: 'کریت',
    statAccuracy: 'دقت',
    // Weapon labels & blurbs
    weaponAwp: 'AWP',
    weaponRifle: 'رایفل',
    weaponLmg: 'مسلسل',
    weaponAwpBlurb: 'سنگین می‌زند اما کم. کریت بالا — یا می‌کشد یا خطا می‌رود.',
    weaponRifleBlurb: 'دمیج و سرعت شلیک متعادل.',
    weaponLmgBlurb: 'زیاد اما ضعیف. دمیج را آرام‌آرام بالا می‌برد.',
    // Armor labels & blurbs
    armorNone: 'بدون جلیقه',
    armorLight: 'جلیقه سبک',
    armorHeavy: 'جلیقه سنگین',
    armorNoneBlurb: 'بیشترین قدرت آتش، اما شکننده.',
    armorLightBlurb: 'کمی از دمیج و کریت کم می‌کند.',
    armorHeavyBlurb: 'از اوج دمیج و کریت زیاد کم می‌کند — جواب AWP.',
    armorNumbers: '{{points}} امتیاز جلیقه · گلوله −30% دمیج، کریت رد می‌شود',
    // Gear in numbers
    gearInfoOpen: 'چطور کار می‌کند',
    gearInfoTitle: 'تجهیزات در عدد',
    gearFragInfo:
      'تا {{max}} دمیج به هدف — جلیقه نجاتش نمی‌دهد؛ ترکش یک دشمن دیگر را هم می‌گیرد. [[defense|دفاع]] ×1.35 می‌خورد، [[maneuver|جاخالی]] ×0.8.',
    gearSmokeInfo: 'دود روی هم‌تیمی: تا {{rounds}} راند −{{mit}}% دمیج گلوله می‌خورد. چاقو و نارنجک دود را نمی‌بینند.',
    gearFlashInfo: 'تا 3 دشمن را {{rounds}} راند کور می‌کند: نصف دقت، بدون کریت.',
    gearMedkitInfo: '{{frac}}% از HP کم‌شده را برمی‌گرداند (دست‌کم {{floor}}). این راند شلیک نمی‌کنی و جلوی چاقو بازی.',
    gearKnifeInfo:
      'رایگان، هر راند. هدفی که شلیک نمی‌کند یا در [[defense|دفاع]] است — {{dmg}} از روی جلیقه، زیر 30% HP اعدام. هدفی در [[attack|حمله]] یا [[maneuver|جاخالی]] — فقط {{weak}}، و آتش نزدیکش را می‌خوری.',
    // Result
    resultWin: 'برد',
    resultTeamWin: 'تیم برد',
    resultDefeat: 'باخت',
    resultWinSub: 'تیمت برد — اسکینی به ارزش سهمت از بانک می‌گیری، تقسیم‌شده بر پایه سهم (MVP).',
    resultTeamWinSub: 'تیمت برد. مبارزت افتاد، اما باز هم اسکینی به ارزش سهمت گرفتی (MVP).',
    resultDefeatSub: 'تیم باخت — راند بعد شانس بیشتری داری.',
    scoreboardTitle: 'جدول امتیاز',
    payout: 'برد',
    total: 'جمع',
    again: 'دوباره',
    wonShort: 'برد',
    viewLog: 'دیدن لاگ',
    roundLog: 'لاگ',
    roundLogTitle: 'لاگ نبرد',
    roundLogEmpty: 'راند اول هنوز در جریان است',
    // Raffle tickets row
    raffleTicketsTitle: '+{{n}} بلیت قرعه‌کشی',
    raffleChipWin: 'برد +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'تریپل +{{n}}',
    raffleChipQuad: 'کواد +{{n}}',
    raffleChipAce: 'ایس +{{n}}',
    raffleChipOneHp: 'برد با 1 HP +{{n}}',
    raffleChipClutch2: 'کلاچ 1v2 +{{n}}',
    raffleChipClutch3: 'کلاچ 1v3 +{{n}}',
    // Winner drop reveal
    dropRevealTapHint: 'برای ادامه لمس کن',
    dropYouTitle: 'دراپ تو',
    dropLabel: 'دراپ',
    watch: 'تماشا',
    // Live now (spectate)
    liveNowTitle: 'الان زنده',
    liveEmpty: 'الان مسابقه‌ای در جریان نیست',
    liveRoundBadge: 'زنده · راند {{n}}',
    spectate: 'تماشا',
    matchOver: 'مسابقه تمام شد',
    logMiss: 'خطا',
    logMissEvade: 'خطا — جاخالی',
    logMissBlind: 'خطا — کور شده',
    logReflect: 'برگشت داده',
    logPunish: 'آتش متقابل',
    logLegend: '✦ کریت از جلیقه رد می‌شود · ⚡ آدرنالین',
    logKilledBy: 'کشته‌شده توسط',
    colKills: 'K',
    canvasMiss: 'خطا',
    canvasMissEvade: 'جاخالی',
    canvasMissBlind: 'کور',
    // History
    historyTitle: 'تاریخچه',
    back: 'برگرد',
    matchDetailError: 'این مسابقه باز نشد. شاید وجود نداشته باشد — تمرین با بات ثبت نمی‌شود.',
    historySubtitle: 'آخرین نبردهای Rush Mid تو.',
    historyEmptyTitle: 'هنوز بازی نکرده‌ای',
    historyEmptyDescription: 'اولین نبرد Rush Mid را بازی کن — همین‌جا نشان داده می‌شود.',
    win: 'برد',
    defeat: 'باخت',
    timeJustNow: 'همین الان',
    timeMinAgo: '{{min}} دقیقه پیش',
    timeHoursAgo: '{{hours}} ساعت پیش',
    timeDaysAgo: '{{days}} روز پیش',
    // Rating
    ratingTab: 'رده‌بندی',
    yourRating: 'رده تو',
    earned: 'کسب‌شده',
    rating: 'رده',
    played: 'بازی‌شده',
    wins: 'برد',
    winsCol: 'برد',
    losses: 'باخت',
    lossesCol: 'باخت',
    playedShort: 'م',
    winsShort: 'ب',
    lossesShort: 'خ',
    winrate: 'نرخ برد',
    player: 'بازیکن',
    topPlayers: 'بهترین بازیکنان',
    ratingUnratedTitle: 'هنوز رده‌ای نداری',
    ratingUnratedDescription: 'برای گرفتن رده در این قالب یک مسابقه بازی کن.',
    ratingEmptyTitle: 'هنوز کسی اینجا نیست',
    ratingEmptyDescription: 'اولین نفری باش که در این قالب بازی می‌کند.',
    // Raffle
    raffleTab: 'قرعه‌کشی',
  },
});

/**
 * Playful CS-flavoured phrases cycled on the asset-loading screen (one swap every
 * couple of seconds) instead of a dull "loading…". Kept out of the typed
 * translations map because `t()` only returns strings; pick by `lang`.
 */
export const LOADING_PHRASES: Record<Language, string[]> = {
  ru: [
    'Накручиваем глушак…',
    'Перезаряжаемся…',
    'Закупаем гранаты…',
    'Точим ножи…',
    'Раскуриваем дымы…',
    'Калибруем сенсу…',
    'Чистим AWP…',
    'Учим раскидки…',
    'Заходим на мид…',
    'Греем наушники…',
    'Зовём тиммейтов…',
    'Разминаем пальцы…',
  ],
  en: [
    'Screwing on the silencer…',
    'Reloading…',
    'Buying grenades…',
    'Sharpening knives…',
    'Lighting up smokes…',
    'Calibrating sensitivity…',
    'Cleaning the AWP…',
    'Learning nade lineups…',
    'Rushing mid…',
    'Warming up the headset…',
    'Calling the teammates…',
    'Stretching fingers…',
  ],
  uz: [
    'Glushitelni burab qoʻyyapmiz…',
    'Qayta oʻqlanmoqdamiz…',
    'Granatalar olyapmiz…',
    'Pichoqlarni charxlaymiz…',
    'Tutun granatalarini yoqamiz…',
    'Sezgirlikni sozlaymiz…',
    'AWP ni tozalaymiz…',
    'Raskidkalarni oʻrganamiz…',
    'Midga kiramiz…',
    'Quloqchinni isitamiz…',
    'Jamoadoshlarni chaqiramiz…',
    'Barmoqlarni qizdiramiz…',
  ],
  fa: [
    'صداخفه‌کن را می‌بندیم…',
    'خشاب عوض می‌کنیم…',
    'نارنجک می‌خریم…',
    'چاقوها را تیز می‌کنیم…',
    'دودها را روشن می‌کنیم…',
    'حساسیت ماوس را تنظیم می‌کنیم…',
    'AWP را تمیز می‌کنیم…',
    'پرتاب نارنجک تمرین می‌کنیم…',
    'می‌زنیم به مید…',
    'هدست را گرم می‌کنیم…',
    'هم‌تیمی‌ها را صدا می‌زنیم…',
    'انگشت‌ها را گرم می‌کنیم…',
  ],
};

/**
 * Real gameplay tips cycled on the matchmaking-search screen (one swap every few
 * seconds). They teach the actual mechanics (stance RPS, knife reads, defensive
 * smoke, enemy flash, grenade armor-break, comeback medkit, armor, economy).
 * Kept out of the typed map for the same reason as LOADING_PHRASES — pick by `lang`.
 */
export const SEARCH_TIPS: Record<Language, string[]> = {
  ru: [
    'Стойки — это камень-ножницы-бумага: Атака бьёт Манёвр, Манёвр бьёт Защиту, Защита бьёт Атаку.',
    'Нож рвёт того, кто защищается, лечится или ставит дым. Но если полезешь на стреляющего — он тебя накажет.',
    'Дым — прикрытие своего: накрой раненого союзника, и два раунда по нему проходит вдвое меньше урона, а он сам продолжает стрелять.',
    'Флешка — наоборот, по врагу: слепит цель и её соседей, два раунда они мажут и не выбивают крит. Кидай, пока враги в полном составе.',
    'Дым не спасает от гранаты и ножа: задымлённого союзника всё равно достанут взрывом или вплотную.',
    'Граната пробивает броню в эпицентре и особенно больно бьёт того, кто встал в глухую Защиту — отсидеться не выйдет. А Манёвр, наоборот, уводит от части взрыва.',
    'Лечишься — в этот раунд не стреляешь и открыт. И чем сильнее ранен, тем больше вернёт аптечка: это отыгрыш из ямы, а не сустейн.',
    'Меньшинство не приговор: каждый боец отстающей команды получает на раунд адреналин-щит (янтарная полоска) — чем больше разрыв, тем толще. Дави числом, но добивай быстро.',
    'Не фокусь толпой одного: чем больше врагов бьёт одну отстающую цель, тем меньше проходит урона (синие цифры — удар погашен). Размазывай огонь по целям.',
    'Защита отражает часть урона обратно атакующему, но сам ты бьёшь слабее.',
    'Манёвр сбивает вражескую точность — хорош против того, кто встал в глухую оборону.',
    'Броня держит поток мелких пуль (пулемёт/автомат вязнут), но снайперский крит её пробивает — от AWP броня не спасёт.',
    'У всех одинаковый бюджет: закупка решает стиль, а не силу. Криты решают.',
    'Не угадывай вслепую — смотри, что соперник делал в прошлом раунде, и читай его.',
    'Тот, кто стреляет, держит одну цель, пока она жива — убей её, чтобы сбить ему фокус.',
    'Приз в победившей команде делят по вкладу — считается не только урон, но и польза: дым, флешка, аптечка. Чем полезнее ты команде, тем больше доля.',
    'Дым и флешка — только в командных режимах: в 1 на 1 их нет.',
    'Нож бесплатный и доступен каждый раунд — это всегда запасной план.',
    'Граната задевает и соседа цели — кидай в скопление врагов.',
    'AWP — редкий тяжёлый выстрел: крит пробивает броню и наказывает отсидку. Но медленный — в упор его переливают из пулемёта/автомата.',
    'Пулемёт бьёт часто и слабо — ровно набивает урон без качелей крита.',
    'Каждый билет добавляет в банк случайную сумму — от половины до 2.5 билета. Победители делят банк по вкладу и получают скин: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    'Нож казнит раненого: пассивная цель с низким HP умирает от удара мгновенно. Не отсиживайся в Защите на последнем издыхании.',
    'Не выбрал действие до конца таймера — сервер сходит за тебя выстрелом в Атаке. Лучше выбери сам.',
    'Обе команды выбиты одновременно — ничья: вход вернётся полностью.',
    'Из живого боя выйти нельзя — за отсутствующего ходит автопилот, а вход и рейтинг решает исход матча. Вернёшься — попадёшь прямо в бой. Автопилот бьёт вслепую, лучше играй сам.',
    'Победы и поражения двигают твой рейтинг (ничья не меняет) — топ во вкладке «Рейтинг». Сид боя раскрывается после матча: любой раунд можно проверить в реплее.',
    'Цель выбираешь сам: тапни врага — весь огонь пойдёт по нему; тапни своего — дым полетит прикрывать его.',
  ],
  en: [
    'Stances are rock-paper-scissors: Attack beats Maneuver, Maneuver beats Defense, Defense beats Attack.',
    'The knife shreds anyone defending, healing or smoking. Charge a shooter, though, and they punish you.',
    'Smoke covers your own: shield a hurt teammate and for two rounds they take only half the gun damage — while they keep shooting.',
    'Flash is the opposite — on the enemy: it blinds the target and its neighbours, so for two rounds they miss and can’t crit. Throw it while the enemy is at full strength.',
    'Smoke won’t save you from a grenade or a knife — a smoked teammate still gets caught by the blast or up close.',
    'A grenade punches through armor at the centre and hits a turtling defender extra hard — you can’t just sit it out. Maneuver, on the other hand, ducks part of the blast.',
    'Healing means you don’t shoot that round and you’re exposed. The more hurt you are, the more the medkit gives back — a comeback tool, not steady sustain.',
    'Being outnumbered isn’t a death sentence: every trailing fighter gets a round-long adrenaline shield (the amber bar) — the bigger the gap, the thicker. Push your numbers, but finish fast.',
    'Don’t dogpile one target: the more enemies focus the same fighter, the less each shot lands (blue numbers — the hit is braced). Spread your fire across targets.',
    'Defense reflects part of the damage back at the attacker, but your own damage is weaker.',
    'Maneuver lowers the enemy’s accuracy — great against someone turtling in Defense.',
    'Armor eats a stream of small bullets (LMG/rifle bog down in it), but a sniper crit punches through — armor won’t save you from the AWP.',
    'Everyone gets the same budget: your buy sets the style, not the power. Crits decide.',
    'Don’t guess blind — watch what your opponent did last round and read them.',
    'Shooters lock onto one target and stick to it until it dies — kill their target to break their focus.',
    'The winning team splits the prize by contribution — damage AND utility: smokes, flashes and medkits all count. The more useful you are, the bigger your cut.',
    'Smoke and flash only exist in team modes — there’s none in 1v1.',
    'The knife is free and available every round — it’s always a backup plan.',
    'A grenade also clips an ally next to the target — throw it into a cluster.',
    'The AWP is a rare heavy shot: its crit punches through armor and punishes turtling. But it’s slow — up close an LMG/rifle out-guns it.',
    'The machine gun fires often and weak — steady damage with no crit swings.',
    'Every ticket adds a random amount to the bank — from half up to 2.5× the ticket. The winners split the bank by contribution and get paid in a skin: a win is worth at least your entry +50%, the ceiling is ×5.',
    'The knife executes the wounded: a passive target on low HP dies to one strike. Don’t turtle in Defense on your last breath.',
    'Pick nothing before the timer runs out and the server shoots for you in Attack. Better pick yourself.',
    'Both teams wiped in the same instant — a draw: your entry comes back in full.',
    'You can’t quit a live fight — an absent player runs on autopilot, and your entry and rating settle with the match result. Come back and you drop straight into the battle. Autopilot shoots blind — better play it yourself.',
    'Wins and losses move your rating (a draw doesn’t) — see the top in the Rating tab. The match seed is revealed afterwards: any round can be verified in the replay.',
    'You pick the target: tap an enemy and your fire goes there; tap a teammate and your smoke covers them.',
  ],
  uz: [
    'Turishlar — tosh-qaychi-qogʻoz: Hujum Manyovrni, Manyovr Himoyani, Himoya Hujumni yengadi.',
    'Pichoq himoyalanayotgan, davolanayotgan yoki tutun qoʻyayotganni yorib tashlaydi. Otayotganga yugursang — jazolaydi.',
    'Tutun — oʻzingnikini yopadi: yarador sherigingni yop, ikki raund unga oʻq zarari yarmi tegadi, oʻzi esa otaveradi.',
    'Flesh — aksincha, dushmanga: nishon va yonidagilarni koʻr qiladi, ikki raund ular xato otadi va krit chiqarolmaydi. Dushman toʻliq kuchda turganda tashla.',
    'Tutun granata va pichoqdan saqlamaydi — tutundagi sherikni baribir portlash yoki yaqindan oladi.',
    'Granata markazda zirhni teshadi va qattiq himoyaga oʻtganni ayniqsa ogʻriq uradi — oʻtirib chiqib boʻlmaydi. Manyovr esa portlashning bir qismidan qochiradi.',
    'Davolansang — oʻsha raund otmaysan va ochiqsan. Qanchalik yarador boʻlsang, aptechka shuncha koʻp qaytaradi — bu chuqurdan chiqish vositasi, doimiy tiklanish emas.',
    'Ozchilik mahkum emas: orqada qolgan har bir jangchi raundga adrenalin-qalqon oladi (sariq chiziq) — farq qancha katta boʻlsa, qalqon shuncha qalin. Son bilan bos, lekin tez tugat.',
    'Bittaga toʻplanma: bitta nishonni qancha koʻp dushman fokuslasa, har biri shuncha kam uradi (koʻk raqamlar — zarba yumshatildi). Olovni nishonlarga taqsimla.',
    'Himoya zararning bir qismini hujumchiga qaytaradi, lekin oʻzing zaifroq urasan.',
    'Manyovr raqib aniqligini pasaytiradi — qattiq himoyaga oʻtganga qarshi zoʻr.',
    'Zirh mayda oʻqlar oqimini ushlaydi (pulemyot/avtomat unda tiqilib qoladi), lekin snayper kriti uni teshadi — AWPdan zirh saqlamaydi.',
    'Hammada bir xil byudjet: xarid uslubni belgilaydi, kuchni emas. Kritlar hal qiladi.',
    'Koʻr-koʻrona taxmin qilma — raqib oʻtgan raundda nima qilganini koʻr va oʻqib ol.',
    'Otuvchilar bitta nishonni oʻlguncha ushlab otadi — fokusni buzish uchun ularning nishonini yoʻq qil.',
    'Gʻolib jamoa mukofotni hissaga koʻra boʻlishadi — faqat zarar emas, foyda ham hisoblanadi: tutun, flesh, aptechka. Jamoaga qancha foydali boʻlsang, ulushing shuncha katta.',
    'Tutun va flesh faqat jamoaviy rejimlarda bor — 1ga1da yoʻq.',
    'Pichoq bepul va har raundda mavjud — bu doim zaxira reja.',
    'Granata nishon yonidagi sherikni ham ilintiradi — toʻplangan joyga tashla.',
    'AWP — kam otadigan ogʻir zarba: kriti zirhni teshadi va oʻtirishni jazolaydi. Lekin sekin — yaqindan uni pulemyot/avtomat oʻtkazib yuboradi.',
    'Pulemyot tez va kuchsiz otadi — krit tebranishlarisiz barqaror zarar.',
    'Har bilet bankka tasodifiy summa qoʻshadi — yarmidan 2.5 biletgacha. Gʻoliblar bankni hissaga koʻra boʻlishib skin sifatida olishadi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    'Pichoq yaradorni qatl qiladi: HP kam passiv nishon bir zarbadan oʻladi. Oxirgi nafasda Himoyada oʻtirma.',
    'Taymer tugaguncha tanlamasang — server sen uchun Hujumda otadi. Yaxshisi oʻzing tanla.',
    'Ikkala jamoa bir vaqtda qulasa — durang: kirish toʻliq qaytadi.',
    'Jonli jangdan chiqib boʻlmaydi — yoʻq oʻyinchi oʻrniga avtopilot yuradi, kirish va reyting oʻyin natijasi bilan hal boʻladi. Qaytsang — toʻgʻri jangga tushasan. Avtopilot koʻr otadi — yaxshisi oʻzing oʻyna.',
    'Gʻalaba va magʻlubiyat reytingni oʻzgartiradi (durang — yoʻq) — top «Reyting» boʻlimida. Oʻyin seedi oʻyindan keyin ochiladi: istalgan raundni replayda tekshirsa boʻladi.',
    'Nishonni oʻzing tanlaysan: dushmanni tap qil — butun olov unga ketadi; sherigingni tap qil — tutun uni yopadi.',
  ],
  fa: [
    'ژست‌ها سنگ‌کاغذ‌قیچی‌اند: حمله جاخالی را می‌برد، جاخالی دفاع را، دفاع حمله را.',
    'چاقو کسی را که دفاع می‌کند، درمان می‌شود یا دود می‌اندازد تکه‌تکه می‌کند. اما به کسی که شلیک می‌کند حمله کنی، تنبیهت می‌کند.',
    'دود پوشش خودی است: هم‌تیمی زخمی را بپوشان تا دو راند نصف دمیج گلوله بخورد — و خودش شلیکش را ادامه بدهد.',
    'فلش برعکس، روی دشمن است: هدف و کناری‌هایش را کور می‌کند، دو راند خطا می‌زنند و کریت نمی‌گیرند. وقتی دشمن کامل است بینداز.',
    'دود جلوی نارنجک و چاقو را نمی‌گیرد — هم‌تیمی زیر دود را انفجار یا ضربه نزدیک می‌گیرد.',
    'نارنجک در مرکز از جلیقه رد می‌شود و کسی را که سفت در دفاع نشسته بدجور می‌زند — نمی‌شود فقط نشست. جاخالی برعکس، بخشی از انفجار را در می‌رود.',
    'درمان یعنی آن راند شلیک نمی‌کنی و بازی. هرچه زخمی‌تر باشی کیت بیشتر برمی‌گرداند — ابزار برگشتن است، نه دوام همیشگی.',
    'کم‌بودن حکم مرگ نیست: هر مبارز تیم عقب‌افتاده یک راند سپر آدرنالین می‌گیرد (نوار کهربایی) — هرچه فاصله بیشتر، سپر ضخیم‌تر. با تعداد فشار بده، اما سریع تمامش کن.',
    'همه روی یک نفر نریزید: هرچه دشمن بیشتری یک هدف را فوکوس کند، هر شلیک کمتر می‌نشیند (عدد آبی — ضربه مهار شد). آتش را بین هدف‌ها پخش کن.',
    'دفاع بخشی از دمیج را به مهاجم برمی‌گرداند، اما ضربه خودت ضعیف‌تر است.',
    'جاخالی دقت دشمن را می‌آورد پایین — برای کسی که سفت در دفاع نشسته عالی است.',
    'جلیقه سیل گلوله‌های ریز را می‌خورد (مسلسل و رایفل در آن گیر می‌کنند)، اما کریت اسنایپر از آن رد می‌شود — جلیقه جلوی AWP را نمی‌گیرد.',
    'بودجه همه یکی است: خرید سبک را می‌سازد، نه قدرت را. کریت‌ها تعیین‌کننده‌اند.',
    'کورکورانه حدس نزن — ببین حریفت راند قبل چه کرد و بخوانش.',
    'کسی که شلیک می‌کند تا مرگ هدف رویش قفل می‌ماند — هدفش را بکش تا فوکوسش بپاشد.',
    'تیم برنده جایزه را به نسبت سهم تقسیم می‌کند — نه فقط دمیج، بلکه فایده هم: دود، فلش و کیت درمان همه حساب‌اند. هرچه برای تیم مفیدتر باشی، سهمت بیشتر است.',
    'دود و فلش فقط در حالت‌های تیمی هستند — در 1v1 خبری از آن‌ها نیست.',
    'چاقو رایگان است و هر راند در دسترس — همیشه نقشه دوم توست.',
    'نارنجک هم‌تیمی کنار هدف را هم می‌گیرد — وسط جمعیت بینداز.',
    'AWP شلیک سنگین و کم‌شمار است: کریتش از جلیقه رد می‌شود و نشستن را تنبیه می‌کند. اما کند است — از نزدیک مسلسل و رایفل از آن جلو می‌زنند.',
    'مسلسل زیاد و ضعیف می‌زند — دمیج یکنواخت بدون نوسان کریت.',
    'هر بلیت مبلغی تصادفی به بانک اضافه می‌کند — از نصف تا 2.5 برابر بلیت. برنده‌ها بانک را به نسبت سهم تقسیم و به شکل اسکین می‌گیرند: برد دست‌کم ورودی +50% می‌ارزد، سقف ×5 است.',
    'چاقو زخمی را اعدام می‌کند: هدف منفعل با HP کم با یک ضربه می‌میرد. با آخرین نفس در دفاع ننشین.',
    'تا پایان تایمر چیزی انتخاب نکنی، سرور به‌جای تو در حمله شلیک می‌کند. بهتر است خودت انتخاب کنی.',
    'هر دو تیم هم‌زمان از پا در بیایند — مساوی: ورودی کامل برمی‌گردد.',
    'از نبرد زنده نمی‌شود بیرون آمد — به‌جای بازیکن غایب خلبان خودکار بازی می‌کند، و ورودی و رده با نتیجه مسابقه تعیین می‌شوند. برگردی، مستقیم وسط نبرد می‌افتی. خلبان خودکار کور می‌زند — بهتر است خودت بازی کنی.',
    'برد و باخت رده‌ات را جابه‌جا می‌کنند (مساوی نه) — بهترین‌ها در تب «رده‌بندی». سید مسابقه بعد از پایان باز می‌شود: هر راندی را می‌شود در پخش بررسی کرد.',
    'هدف را خودت انتخاب می‌کنی: دشمن را لمس کن تا همه آتش سمت او برود؛ هم‌تیمی را لمس کن تا دود رویش بنشیند.',
  ],
};
